import React from 'react';
import './waves.scss';

export default ({ flip, shift, className, style, waves = 1 }) => {
  const count = Array.from({ length: waves }).map((_, i) => i);

  return (
    <div
      className={`waves-container ${className || ''} ${
        flip ? 'waves-container__flip' : ''
      }`}
      style={style}
    >
      <div className="ocean">
        {count.map(i => (
          <div
            className={`wave wave-${i} ${shift ? 'wave__shift' : ''}`}
            key={`wave__${i}`}
          />
        ))}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// /app/apps/ms/src/components/Waves/index.js